import {inject} from 'aurelia-framework';

export function useCookie(target: any, key: string) {

    // property value
    //var _val = target[key];

    //restore from  cookie
    var val = "FRED";

    var descriptor = Object.getOwnPropertyDescriptor(target, key);
    alert(descriptor.get);

    //// property getter
    //var getter = function () {
    //    return val;
    //};

    //// property setter
    //var setter = function (newVal) {
    //    val = newVal;
    //};

    //// Delete property.
    //if (delete target[key]) {
    //    // Create new property with getter and setter
    //    Object.defineProperty(target, key, {
    //        get: getter,
    //        set: setter
    //    });
    //}
}
